<div class="guided-search-dialog-container">
  <app-close-button contrast="dark" (closeCalled)="onCloseClick()">
  </app-close-button>
  <app-guided-search [selectedOption]="data.selectedOption" [data]="data">
  </app-guided-search>
</div>
